// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class SiteGeoResource extends Resource {
    basePath: string = 'sites/sites/geo/';

    objectPath: string = 'sites/sites/geo/{ident}/';
}
